import { combineReducers } from 'redux'
import setup from './setup'
import warehouseSetup from './warehouse-setup'
import workspaceSettings from './workspace-settings'
import sourceSetup from './source-setup'
import sourceSchema from './source-schema'
import sourceSettings from './source-settings'
import workspaceDestinations from './workspace-destinations'
import workspaceSources from './workspace-sources'
import partners from './partners'
import sourceDebugger from './source-debugger'

export default combineReducers({
  setup,
  warehouseSetup,
  workspaceSettings,
  sourceSettings,
  sourceSetup,
  sourceSchema,
  workspaceDestinations,
  workspaceSources,
  partners,
  sourceDebugger
})
